import { useEffect, useState } from "react";
import Pic from "../../assets/pic.png";
import "../css/About.css";
import { getFirst } from '../../utils/PdfUtils';

export default function About() {

    const [state, setState] = useState<string>("FULL-STACK DEVELOPER");
    const [value, setValue] = useState<number>(0);

    useEffect(() => {       

        function changeStack(value : number){  
            const stacks = ["BACKEND DEVELOPER", "FRONTEND DEVELOPER", "ANDROID DEVELOPER", "FULL-STACK DEVELOPER"];    

            setValue(value+1);         
            if(value === stacks.length-1){
                setValue(0);
            }
            setState(stacks[value]);
        }

        const interval = setInterval(() => {
            changeStack(value);
        }, 2000);

        return () => clearInterval(interval);
    }, [value]);

    return (
        <div className="about fadeIn">
            <div className="content-about">
                <img className="img-about" src={Pic} alt=""></img>
                <div className="txtBtn-about">
                    <h1 className="title-about">HOLA, SOY</h1>
                    <h1 className="title-about">RAMIRO DOMINGUEZ</h1>
                    <h1 className="title-about">{state}</h1>
                    <p className="p-about">
                        Soy una persona proactiva,
                        persistente y autodidácta. Disfruto
                        trabajar en equipo, encontrarme con
                        nuevos desafíos, debatir soluciones, aprender de los demás y
                        compartir mi conocimiento. Mi motivación es superarme
                        día a día, aspiro a seguir creciendo
                        como persona y como profesional.
                    </p>
                    <a className="btn-about" href={getFirst()} target="_blank" rel="noreferrer noopener">DESCARGAR CV</a>
                </div>
            </div>
        </div>
    );
}